import React, { StrictMode } from "react";
import "./styles/base.scss";
import { HelmetProvider } from "react-helmet-async";
import { AppProvider } from "./context/appContext";
import GlassLoading from "./components/GlassLoading/GlassLoading";
import Routes from "./routes";
import { UserProvider } from "./context/userContext";
import { AttachmentsProvider } from "./context/attachmentsContext";
import { LocalityProvider } from "./context/localityContext";
import AppToastContainer from "./components/Toast/AppToastContainer";
import { ExternalProjectsProvider } from "./context/externalProjectsContext";
import { ReleaseFlowProvider } from "./context/releaseFlowContext";

function App() {
  return (
    <StrictMode>
      <HelmetProvider>
        <AppProvider>
          <LocalityProvider>
            <AttachmentsProvider>
              <UserProvider>
                <ExternalProjectsProvider>
                  <ReleaseFlowProvider>
                    <GlassLoading />
                    <Routes />
                  </ReleaseFlowProvider>
                  <AppToastContainer />
                </ExternalProjectsProvider>
              </UserProvider>
            </AttachmentsProvider>
          </LocalityProvider>
        </AppProvider>
      </HelmetProvider>
    </StrictMode>
  );
}

export default App;
